import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "status-check",
  "use": "status-check-usage",
  "viewBox": "0 0 9 7",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 9 7\" id=\"status-check\"><path d=\"m2.637 5.185-1.7-1.63L0 4.45l2.246 2.152.002-.002.41.393L8.998.92 8.044.004\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol